/**
 * Offre « à l'achat de X, obtenez Y » — choix du cadeau, puis ajout des deux lignes.
 *
 * Le PRIX n'est jamais calculé ici : la remise automatique Shopify « Achetez X, obtenez Y »
 * s'applique côté serveur. Ce fichier ne fait que composer le panier. Un client qui
 * bidouillerait ce JS n'obtiendrait rien de plus — au pire un panier sans remise.
 *
 * Rudy A. 2026-09-11 — le modal ne touche plus au panier. « Sélectionner » mémorise le
 * choix (mémoire + sessionStorage par produit déclencheur) et le bandeau l'affiche. C'est
 * « Ajouter au panier » qui envoie botte + cadeau en un seul appel (/cart/add.js, items[]),
 * via un écouteur submit en phase de capture sur le formulaire principal. Les clients B2B
 * (body.b2b-customer / tag b2b) ne sont jamais interceptés : b2b-cart.js garde la main.
 */
(function () {
  'use strict';

  function euros(el) { return el ? el.value : null; }

  function formulairePrincipal() {
    return document.querySelector('.js-product-form-main') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function variantDeclencheur() {
    // La variante achetée est celle du formulaire produit principal. On lit le champ au
    // moment du clic plutôt qu'au chargement : le client a pu changer de pointure entre-temps.
    var form = formulairePrincipal();
    if (!form) return null;
    var input = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function clientB2B(form) {
    if (document.body.classList.contains('b2b-customer')) return true;
    var flag = form && form.querySelector('[data-user-has-b2b-tag]');
    return !!(flag && flag.dataset.userHasB2bTag === 'true');
  }

  function ouvrirTiroir() {
    // Le thème expose plusieurs mécanismes selon les pages : on tente le tiroir, sinon
    // on redirige vers le panier pour ne jamais laisser l'utilisateur sans retour visuel.
    var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var trigger = document.querySelector('[data-cart-drawer-toggle], .js-cart-drawer-open, a[href="/cart"]');
    if (trigger && trigger.click) { trigger.click(); return; }
    window.location.href = '/cart';
  }

  /**
   * Après un ajout réussi : même rendu que product-form.js quand la réponse contient les
   * sections (icône panier + contenu du tiroir, qui s'ouvre tout seul) ; sinon on rafraîchit
   * le tiroir et on l'ouvre.
   */
  function apresAjout(data) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    var PF = window.customElements && customElements.get('product-form');
    if (data && data.sections && drawer && typeof drawer.renderContents === 'function') {
      if (PF && typeof PF.updateCartIcon === 'function' && data.sections['cart-icon-bubble']) PF.updateCartIcon(data);
      drawer.renderContents(data, true);
      return;
    }
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
    ouvrirTiroir();
  }

  function sectionsTiroir() {
    var sections = 'cart-icon-bubble';
    var drawer = document.querySelector('cart-drawer');
    var section = drawer && drawer.closest('.shopify-section');
    if (section) sections += ',' + section.id.replace('shopify-section-', '');
    return sections;
  }

  /**
   * Pastilles d'options du cadeau (Rudy A. 2026-09-10).
   * Filtrage directionnel comme le PDP : pour l'option n, une valeur est visible si une
   * variante compatible avec les choix 0..n-1 la porte ; elle est barree (et desactivee) si
   * aucune de ces variantes n'est disponible. Une selection qui disparait est reprise sur la
   * premiere valeur visible et disponible — jamais de rangee vide. L'id de la variante
   * resolue est ecrit dans le champ cache [data-offre-select] : le reste du fichier ne change pas.
   * Retourne { preselectionner(o), variante() } pour le bandeau (Rudy A. 2026-09-11).
   */
  function initPicker(item, select) {
    var variantes;
    try { variantes = JSON.parse(item.getAttribute('data-offre-variants') || '[]'); }
    catch (e) { variantes = []; }
    var groupes = Array.prototype.slice.call(item.querySelectorAll('[data-offre-opt]'));

    function parId(id) {
      for (var i = 0; i < variantes.length; i++) { if (String(variantes[i].id) === String(id)) return variantes[i]; }
      return null;
    }

    if (!groupes.length || !variantes.length) {
      // variante par defaut : id deja dans le champ cache
      return { preselectionner: function () {}, variante: function () { return parId(select.value); } };
    }

    function radios(g) { return Array.prototype.slice.call(g.querySelectorAll('.offre-opt__radio')); }
    function libelle(r) { return r.nextElementSibling; }
    function choix() {
      return groupes.map(function (g) {
        var r = g.querySelector('.offre-opt__radio:checked');
        return r ? r.value : null;
      });
    }
    function compatible(v, sel, jusqua) {
      for (var i = 0; i < jusqua; i++) { if (sel[i] !== null && v.o[i] !== sel[i]) return false; }
      return true;
    }

    function recalculer() {
      groupes.forEach(function (g, k) {
        var sel = choix();
        var liste = radios(g);
        liste.forEach(function (r) {
          var existe = false, dispo = false;
          for (var i = 0; i < variantes.length; i++) {
            var v = variantes[i];
            if (v.o[k] !== r.value || !compatible(v, sel, k)) continue;
            existe = true;
            if (v.a) { dispo = true; break; }
          }
          var lab = libelle(r);
          if (lab) { lab.hidden = !existe; lab.classList.toggle('is-unavailable', existe && !dispo); }
          r.disabled = !dispo;
          r.hidden = !existe;
        });
        var courant = g.querySelector('.offre-opt__radio:checked');
        if (!courant || courant.hidden || courant.disabled) {
          var visibles = liste.filter(function (r) { return !r.hidden; });
          var cible = visibles.filter(function (r) { return !r.disabled; })[0] || visibles[0];
          if (courant) courant.checked = false;
          if (cible) cible.checked = true;
        }
      });
      var finale = choix();
      var trouvee = null;
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], ok = true;
        for (var j = 0; j < finale.length; j++) { if (finale[j] === null || v.o[j] !== finale[j]) { ok = false; break; } }
        if (ok) { trouvee = v; break; }
      }
      select.value = (trouvee && trouvee.a) ? String(trouvee.id) : '';
    }

    function cocher(o) {
      groupes.forEach(function (g, k) {
        radios(g).forEach(function (r) { r.checked = (r.value === o[k]); });
      });
      recalculer();
    }

    // Preselection : premiere variante disponible (sinon la premiere), pour que le bouton
    // fonctionne des l'ouverture.
    var depart = null;
    for (var i = 0; i < variantes.length; i++) { if (variantes[i].a) { depart = variantes[i]; break; } }
    depart = depart || variantes[0];
    cocher(depart.o);

    item.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('offre-opt__radio')) recalculer();
    });

    return {
      preselectionner: function (o) { if (o && o.length === groupes.length) cocher(o); },
      variante: function () { return parId(select.value); }
    };
  }

  function init(racine) {
    var bloc = racine.querySelector('[data-offre]');
    var modal = racine.querySelector('[data-offre-modal]');
    if (!bloc || !modal) return;
    if (modal.dataset.offreLie === '1') return;   // pas de double liaison au re-render de section
    modal.dataset.offreLie = '1';

    var cle = 'offre:' + (bloc.getAttribute('data-offre-produit') || 'produit');
    var choix = null;          // { pid, vid, o: [...], img, titre }
    var pickers = {};          // pid -> { item, api }

    var erreur = modal.querySelector('[data-offre-erreur]');
    var erreurBloc = bloc.querySelector('[data-offre-erreur-bloc]');
    function montrerErreur(msg) {
      if (!erreur) return;
      erreur.textContent = msg;
      erreur.hidden = false;
    }
    function montrerErreurBloc(msg) {
      if (!erreurBloc) { montrerErreur(msg); return; }
      erreurBloc.textContent = msg;
      erreurBloc.hidden = false;
    }
    function ouvrir() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function fermer() { modal.hidden = true; document.body.style.overflow = ''; if (erreur) erreur.hidden = true; }

    // ── Mémoire du choix ─────────────────────────────────────────────────────────────
    function lire() {
      try { var brut = window.sessionStorage.getItem(cle); return brut ? JSON.parse(brut) : null; }
      catch (e) { return null; }
    }
    function ecrire(c) {
      try { if (c) window.sessionStorage.setItem(cle, JSON.stringify(c)); else window.sessionStorage.removeItem(cle); }
      catch (e) { /* stockage indisponible : le choix reste en mémoire */ }
    }

    var initial = bloc.querySelector('[data-offre-initial]');
    var choisi = bloc.querySelector('[data-offre-choisi]');
    var vignette = bloc.querySelector('[data-offre-choisi-img]');
    var nom = bloc.querySelector('[data-offre-choisi-nom]');
    var options = bloc.querySelector('[data-offre-choisi-options]');

    function rendreBandeau() {
      if (erreurBloc) erreurBloc.hidden = true;
      if (!choisi || !initial) return;
      if (!choix) { choisi.hidden = true; initial.hidden = false; return; }
      if (vignette) {
        if (choix.img) { vignette.src = choix.img; vignette.alt = choix.titre || ''; vignette.hidden = false; }
        else { vignette.removeAttribute('src'); vignette.hidden = true; }
      }
      if (nom) nom.textContent = choix.titre || '';
      if (options) {
        var o = (choix.o || []).filter(function (v) { return v && v !== 'Default Title'; });
        options.textContent = o.join(' / ');
        options.hidden = !o.length;
      }
      initial.hidden = true;
      choisi.hidden = false;
    }

    function retenir(c) { choix = c; ecrire(c); rendreBandeau(); }

    racine.querySelectorAll('[data-offre-open]').forEach(function (b) { b.addEventListener('click', ouvrir); });
    modal.querySelectorAll('[data-offre-close]').forEach(function (b) { b.addEventListener('click', fermer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) fermer(); });

    modal.querySelectorAll('[data-offre-item]').forEach(function (item) {
      var btn = item.querySelector('[data-offre-pick]');
      var select = item.querySelector('[data-offre-select]');
      if (!btn || !select) return;
      var api = initPicker(item, select);
      var pid = item.getAttribute('data-offre-id');
      pickers[pid] = { item: item, api: api };

      btn.addEventListener('click', function () {
        var idCadeau = euros(select);
        if (!idCadeau) { montrerErreur(window.theme && theme.strings && theme.strings.offreNoVariant || 'Choisissez une option.'); return; }
        var v = api.variante();
        retenir({
          pid: pid,
          vid: Number(idCadeau),
          o: (v && v.o) || [],
          img: (v && v.img) || item.getAttribute('data-offre-img') || '',
          titre: item.getAttribute('data-offre-titre') || ''
        });
        fermer();
      });
    });

    // « Modifier » : rouvre le modal avec les pastilles du choix mémorisé cochées.
    bloc.querySelectorAll('[data-offre-modifier]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (choix && pickers[choix.pid]) pickers[choix.pid].api.preselectionner(choix.o);
        ouvrir();
      });
    });
    bloc.querySelectorAll('[data-offre-retirer]').forEach(function (b) {
      b.addEventListener('click', function () { retenir(null); });
    });

    // Restauration après rechargement : seulement si la variante existe encore et est disponible.
    var memo = lire();
    if (memo && pickers[memo.pid]) {
      var p = pickers[memo.pid];
      p.api.preselectionner(memo.o);
      var v = p.api.variante();
      if (v && v.a && String(v.id) === String(memo.vid)) { choix = memo; rendreBandeau(); }
      else ecrire(null);
    }

    // ── Ajout botte + cadeau au clic sur « Ajouter au panier » ────────────────────────
    var form = formulairePrincipal();
    if (!form || form.dataset.offreLie === '1') return;
    form.dataset.offreLie = '1';

    form.addEventListener('submit', function (e) {
      if (!choix) return;
      if (clientB2B(form)) return;                              // B2B : b2b-cart.js garde la main
      var btn = form.querySelector('[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var idBotte = variantDeclencheur();
      if (!idBotte) return;                                     // validation normale du thème
      var champQte = form.querySelector('[name="quantity"]');
      var qte = parseInt(champQte && champQte.value, 10) || 1;
      var max = champQte && parseInt(champQte.getAttribute('max'), 10);
      if (max && qte > max) return;                             // le thème plafonne et avertit

      e.preventDefault();
      e.stopImmediatePropagation();
      if (erreurBloc) erreurBloc.hidden = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [
            { id: Number(idBotte), quantity: qte },
            { id: Number(choix.vid), quantity: 1 }
          ],
          sections: sectionsTiroir(),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Ajout impossible.');
          apresAjout(res.data);
        })
        .catch(function (err) { montrerErreurBloc(err.message); })
        .finally(function () {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-loading');
        });
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Re-liaison apres un rendu de section par l'editeur de theme.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
